// function initVideoPlayer()
// {
//     var videoIdInput = document.querySelector('input[name="videoid"]');
//     var videoSource = videoIdInput.value;

//     var video = document.getElementById('html5-player');
//     var playButton = document.getElementById('play-button');
//     var pauseButton = document.getElementById('pause-button');

//     playButton.addEventListener('click', function () {
//         video.play();
//         playButton.style.display = 'none';
//         //pauseButton.style.display = 'flex';
//     });

//     pauseButton.addEventListener('click', function () {
//         video.pause();
//        // playButton.style.display = 'flex';
//        // pauseButton.style.display = 'none';
//     });

//     video.addEventListener('ended', function () {
//         playButton.style.display = 'flex';
//         //pauseButton.style.display = 'none';
//         video.currentTime = 0;
//     });
// }

// document.addEventListener('DOMContentLoaded', function() {
//     var videoElement = document.getElementById('html5-player');
//     if (videoElement) {
//         initVideoPlayer();
//     }
// });

function initVideoPlayer()
{
    var videoIdInput = document.querySelector('input[name="videoid"]');
    var videoSource = videoIdInput.value;

    var video = document.getElementById('html5-player');
    var playButton = document.getElementById('play-button');
    var pauseButton = document.getElementById('pause-button');
    var isHoveringPlayButton = false; // Track if play button is being hovered

    playButton.addEventListener('click', function () {
        video.play();
        video.controls = true; // Show browser controls on play
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
    });

    pauseButton.addEventListener('click', function () {
        video.pause();
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
    });

    video.addEventListener('ended', function () {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
        video.currentTime = 0;
        video.controls = false; // Hide controls on video end
    });

    video.addEventListener('play', function () {
        playButton.style.display = 'none';
        pauseButton.style.display = 'flex';
        pauseButton.style.opacity = '0';
    });

    video.addEventListener('pause', function () {
        playButton.style.display = 'flex';
        pauseButton.style.display = 'none';
    });

    playButton.addEventListener('mouseover', function () {
        isHoveringPlayButton = true;
    });

    playButton.addEventListener('mouseout', function () {
        isHoveringPlayButton = false;
    });

    // Handle play/pause button visibility based on video state
    function updateButtonVisibility() {
        if (!video.paused && !isHoveringPlayButton) {
            playButton.style.display = 'none';
            pauseButton.style.display = 'flex';
        } else {
            playButton.style.display = 'flex';
            pauseButton.style.display = 'none';
        }
    }

    // Update button visibility initially and on video state changes
    updateButtonVisibility();
    video.addEventListener('play', updateButtonVisibility);
    video.addEventListener('pause', updateButtonVisibility);
}

document.addEventListener('DOMContentLoaded', function() {
    var videoElement = document.getElementById('html5-player');
    if (videoElement) {
        // Disable default controls
        videoElement.controls = false;

        // Initialize custom video player
        initVideoPlayer();
    }

    // Show the play button initially
    var playButton = document.getElementById('play-button');
    var pauseButton = document.getElementById('pause-button');
    playButton.style.display = 'flex';
    pauseButton.style.display = 'none';
});
